import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';

import { BACKEND_URL } from "../lib/backendUrl";
const API = `${BACKEND_URL}/api`;

const PaymentButton = ({ planId, planName, billingPeriod = 'monthly', buttonText, className }) => {
  const [loading, setLoading] = useState(false);
  const { token, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();

  const handlePayment = async () => {
    if (!isAuthenticated) {
      toast({
        title: 'Authentication Required',
        description: 'Please sign in to subscribe',
        variant: 'destructive'
      });
      navigate('/login');
      return;
    }

    setLoading(true);

    try {
      const originUrl = window.location.origin;

      const response = await axios.post(
        `${API}/payments/create-checkout`,
        {
          plan_id: planId,
          origin_url: originUrl,
          billing_period: billingPeriod
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.url) {
        window.location.href = response.data.url;
      } else {
        throw new Error('No checkout URL received');
      }
    } catch (error) {
      console.error('Payment error:', error);
      toast({
        title: 'Payment Error',
        description: error.response?.data?.detail || 'Failed to initiate payment',
        variant: 'destructive'
      });
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handlePayment}
      disabled={loading}
      className={className}
      data-testid={`payment-btn-${planId}`}
    >
      {loading ? 'Processing...' : buttonText}
    </Button>
  );
};

export default PaymentButton;
